// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1bIWr","messages":"Chat_messages__3G7sm","dateDivider":"Chat_dateDivider__3kjVZ"};